import { useMemo } from 'react'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import PageContent from './components/PageContent'

const List = () => {
  const pageContext: PageContextPayload = useMemo(() => ({
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <PageContent />
    </PageContext.Provider>
  )
}

export default List
